import sanitizeHtml from 'sanitize-html'

export const sanitizeConfig = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'a', 'h2']),
  allowedAttributes: {
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
    a: ['href'],
    h2: ['id'],
  },
}
